// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2kwqo","name":"ConsentHeader_name__1kjV7","birthday":"ConsentHeader_birthday__3wYdd","skeleton":"ConsentHeader_skeleton__3op1L"};